import { FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { mustNotBeBlankValidator } from '../../common';
import { ListQueryParam } from '../../common/constants';
import { ListRange, SearchCriteriaBase } from '../../common/models';
import { SecurityCheckTypeEnum, SecurityQuestionGroupEnum } from '../constants/security-check.constant';

export interface SecurityCheckQuestionsCardModel {
  title: string;
  icon: string;
  checkType: SecurityCheckTypeEnum;
  languageControl: UntypedFormControl;
  languageKey$: Observable<string>;
  questionGroupsControl: UntypedFormControl;
}

export class SecurityQuestionModel {
  group: SecurityQuestionGroupEnum | null = null;
  id?: number | null = null;
  questionTranslations: SecurityQuestionQuestionTranslationModel | null = null;
  type: SecurityCheckTypeEnum | null = null;

  constructor(params?: SecurityQuestionModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class SecurityQuestionQuestionTranslationModel {
  DE: string | null = null;
  CS: string | null = null;
  EN: string | null = null;
  ES: string | null = null;
  HU: string | null = null;
  PL: string | null = null;
  PT: string | null = null;
  RO: string | null = null;
  RU: string | null = null;
  ZH: string | null = null;
  IT: string | null = null;
  FR: string | null = null;
  JA: string | null = null;
  UK: string | null = null;
  HI: string | null = null;
  SK: string | null = null;
  SR: string | null = null;
  TH: string | null = null;
  TR: string | null = null;

  constructor(params?: SecurityQuestionQuestionTranslationModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class SecurityQuestionQuestionTranslationForm {
  constructor(
    model: SecurityQuestionQuestionTranslationModel,
    public DE: FormControl<string> = new FormControl<string>(model.DE),
    public CS: FormControl<string> = new FormControl<string>(model.CS),
    public EN: FormControl<string> = new FormControl<string>(model.EN, [Validators.required, mustNotBeBlankValidator]),
    public ES: FormControl<string> = new FormControl<string>(model.ES),
    public HU: FormControl<string> = new FormControl<string>(model.HU),
    public PL: FormControl<string> = new FormControl<string>(model.PL),
    public PT: FormControl<string> = new FormControl<string>(model.PT),
    public RO: FormControl<string> = new FormControl<string>(model.RO),
    public RU: FormControl<string> = new FormControl<string>(model.RU),
    public ZH: FormControl<string> = new FormControl<string>(model.ZH),
    public IT: FormControl<string> = new FormControl<string>(model.IT),
    public FR: FormControl<string> = new FormControl<string>(model.FR),
    public JA: FormControl<string> = new FormControl<string>(model.JA),
    public UK: FormControl<string> = new FormControl<string>(model.UK),
    public HI: FormControl<string> = new FormControl<string>(model.HI),
    public SK: FormControl<string> = new FormControl<string>(model.SK),
    public SR: FormControl<string> = new FormControl<string>(model.SR),
    public TH: FormControl<string> = new FormControl<string>(model.TH),
    public TR: FormControl<string> = new FormControl<string>(model.TR),
  ) {}
}

export class SecurityAddQuestionForm {
  constructor(
    model: SecurityQuestionModel,
    fb: FormBuilder,
    public group: FormControl<SecurityQuestionGroupEnum> = new FormControl<SecurityQuestionGroupEnum>(model.group),
    public questionTranslations: FormGroup<SecurityQuestionQuestionTranslationForm> | null = null,
    public type: FormControl<SecurityCheckTypeEnum> = new FormControl<SecurityCheckTypeEnum>(model.type),
  ) {
    this.questionTranslations = fb.group(
      new SecurityQuestionQuestionTranslationForm(
        new SecurityQuestionQuestionTranslationModel(model.questionTranslations),
      ),
    );
  }
}

export class SecurityQuestionSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Size] = 1000;

  constructor(params?: SecurityQuestionSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface SecurityQuestionTree {
  [SecurityCheckTypeEnum.Arrival]: SecurityQuestionsByGroup;
  [SecurityCheckTypeEnum.Departure]: SecurityQuestionsByGroup;
}

export interface SecurityQuestionsByGroup {
  [SecurityQuestionGroupEnum.Driver]: SecurityQuestionModel[];
  [SecurityQuestionGroupEnum.Inspection]: SecurityQuestionModel[];
  [SecurityQuestionGroupEnum.Mechanical]: SecurityQuestionModel[];
}
